import React, { useState, memo } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { SinglelineTextField } from 'app/pages/Survey/Subject/elements';
import { Unit } from 'app/pages/Survey/Subject/elements';
import { useDigitInputAnswer } from './hooks';

function Answer() {
  const [isArrowShow, setArrowShow] = useState(false);
  const config = useDigitInputAnswer(setArrowShow);

  const engine = useEngineInstance();
  const id = useSubjectId();
  const { unittxt } = engine.getSubjectData(id);

  return (
    <>
      <SinglelineTextField
        type="number"
        {...config}
      />
      { unittxt &&
        <Unit
          unittxt={unittxt}
          isArrowShow={isArrowShow}
        />
      }
    </>
  );
}

export default memo(Answer);
